import React, { useContext, useState, useEffect } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './css/style.css';
import './css/responsive.css';
 
import prestamo from './images/prestamo.png';
import documento from './images/documento.png';
import hombre from './images/hombre.png';
import ahorro from './images/ahorros.png'; 
import Lottie from 'react-lottie-player';
 
import mouseAnimation from './images/MouseAnimation.json';
import LogoDigital from './images/2Digital.png';
 
import { Link } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import { Modal, Button, Form, Spinner } from 'react-bootstrap'; // Importa los componentes necesarios de react-bootstrap
import { Alert, AlertTitle } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Escudo from '../Login/assets/LogoBlanco.png'
import CircularProgress from '@mui/material/CircularProgress'; // Importa el CircularProgress de Material-UI
import { useNavigate, useLocation } from 'react-router-dom';
import { ContextSession } from '../../services/ContextSession';
import { FaWhatsapp } from 'react-icons/fa'; // Librería para íconos
import Tooltip from '@mui/material/Tooltip';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Typography,
    Grid,
    Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import constancia from '../../components/constancia.png';
import preanalisisFoto from '../../components/hipotecario.png';

const ServiciosPortal = () => {
    let sessi = useContext(ContextSession);
    const isMobile = useMediaQuery('(max-width:450px)'); // Detectar si es una pantalla móvil
    const isMobile2 = useMediaQuery('(max-width:991px)'); // Detectar si es una pantalla móvil
    const [showModal, setShowModal] = useState(false);
    const [showModalCodigo, setShowModalCodigo] = useState(false);
    const [showResultModal, setShowResultModal] = useState(false);
    const [resultMessage, setResultMessage] = useState('');
    const [resultType, setResultType] = useState('success'); // 'success' or 'error'
    const [dni, setDni] = useState('');
    const [correo, setCorreo] = useState('');
    const [loading, setLoading] = useState(false); // Nuevo estado para manejar la carga
    const [verificationCode, setVerificationCode] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const location = useLocation(); // Hook para detectar la ubicación actual
    const [open, setOpen] = useState(true);

    const handleCloseAviso = () => {
        setOpen(false);
    };

    useEffect(() => {
        // Crear el elemento <link> para el CSS de Bootstrap
        const bootstrapCss = document.createElement('link');
        bootstrapCss.rel = 'stylesheet';
        bootstrapCss.href = 'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css';
        document.head.appendChild(bootstrapCss);

        // Crear el elemento <script> para jQuery (sin async)
        const jqueryScript = document.createElement('script');
        jqueryScript.src = 'https://code.jquery.com/jquery-3.5.1.min.js';
        document.body.appendChild(jqueryScript);

        // Crear el elemento <script> para Popper.js
        const popperScript = document.createElement('script');
        popperScript.src = 'https://cdn.jsdelivr.net/npm/@popperjs/core@2.5.4/dist/umd/popper.min.js';
        popperScript.async = true;
        document.body.appendChild(popperScript);

        // Crear el elemento <script> para el JS de Bootstrap
        const bootstrapScript = document.createElement('script');
        bootstrapScript.src = 'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js';
        jqueryScript.onload = () => {
            document.body.appendChild(bootstrapScript);
        };

        // Limpieza de los scripts y estilos cuando se navegue a /Login
        /*if (location.pathname === '/Login') {
            document.head.removeChild(bootstrapCss);
            document.body.removeChild(jqueryScript);
            document.body.removeChild(popperScript);
            if (document.body.contains(bootstrapScript)) {
                document.body.removeChild(bootstrapScript);
            }
        }*/

        // Cleanup al desmontar el componente
        return () => {
            // Limpia los elementos cuando el componente se desmonte
            /*document.head.removeChild(bootstrapCss);
            document.body.removeChild(jqueryScript);
            document.body.removeChild(popperScript);
            if (document.body.contains(bootstrapScript)) {
                document.body.removeChild(bootstrapScript);
            }*/
        };
    }, [/*location.pathname*/]); // Se ejecuta cuando la ruta cambia


    const handleClose = () => {
        setShowModal(false);
        setShowResultModal(false);
        setDni(''); // Limpiar el campo DNI
        setCorreo(''); // Limpiar el campo Correo
        setErrorMessage2(''); // Limpiar el mensaje de error al cerrar el Modal
    };

    const handleCloseCodigo = () => {
        setShowModalCodigo(false);
        setShowResultModal(false);
    };

    const handleShow = () => setShowModal(true);

    const handleShowCodigo = () => {
        setShowModal(false);
        setShowModalCodigo(true);
    }

    const [errorMessage2, setErrorMessage2] = useState('');
    const [showChangeEmailButton, setShowChangeEmailButton] = useState(false); // Inicialmente será false


    const handleVerify = async (event) => {
        event.preventDefault();
        setLoading(true); // Mostrar el CircularProgress
        setErrorMessage(''); // Reiniciar el mensaje de error
        sessi.setVariable("CodigoContrato", null);

        // Validaciones
        if (dni.length !== 13) {
            setErrorMessage2('El número de identidad debe tener 13 dígitos.');
            setLoading(false);
            return;
        }

        // Validación simple de correo
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(correo)) {
            setErrorMessage2('El correo electrónico no tiene un formato válido.');
            setLoading(false);
            return;
        }

        // Si pasa las validaciones, continúa con la solicitud a la API
        const formData = new FormData();
        formData.append('dni', dni);
        formData.append('correo', correo);

        try {
            const response = await fetch(`${sessi.ip}/api/biometriaverificacion/`, {
                method: 'POST',
                body: formData
            });

            if (response.ok) {
                setErrorMessage2(''); // Limpiar el mensaje de error al cerrar el Modal
                handleShowCodigo();
            } else if (response.status === 404) {
                setErrorMessage2(''); // Limpiar el mensaje de error al cerrar el Modal
                const errorData = await response.json();
                setResultType('error');

                // Verificar si el mensaje de error contiene el texto "Ya existe usuario con el DNI proporcionado"
                if (errorData.error.includes("Ya existe usuario con el DNI proporcionado" || errorData.error.includes("No se encontró información válida para el DNI proporcionado"))) {
                    setResultMessage(errorData.error); // Solo el mensaje de error sin texto adicional
                    setShowChangeEmailButton(false); // No mostrar el botón
                } else if (errorData.error.includes("No se encontró información válida para el DNI proporcionado")) {
                    setResultMessage(`${errorData.error}. Presentarse a la Oficina de INJUPEMP más cercana para realizar el proceso de afiliación.`);
                    setShowChangeEmailButton(false); // No mostrar el botón
                } else {
                    // Agregar el texto adicional solo si no contiene el mensaje específico
                    setResultMessage(`${errorData.error}. Si ha cambiado de correo, por favor, acuda a la Oficina de INJUPEMP más cercana para actualizar sus datos.`);
                    //setShowChangeEmailButton(false);
                    setShowChangeEmailButton(true); // Mostrar el botón "Solicitar Cambio De Correo"
                }

            } else {
                setResultType('error');
                setResultMessage('Ocurrió un error inesperado.');
                setShowChangeEmailButton(false); // No mostrar el botón
            }
        } catch (error) {
            setResultType('error');
            setErrorMessage('Error de conexión a internet.');
            setShowChangeEmailButton(false); // No mostrar el botón
        }

        setLoading(false); // Ocultar el CircularProgress
        setShowResultModal(true);
    };

    const { setCanAccessUpdateEmail } = useContext(ContextSession);

    const handleChangeEmailClick = () => {
        // Cambiar el estado a verdadero para permitir el acceso a la ruta
        setCanAccessUpdateEmail(true);
        navigate('/ActualizarCorreo');
    };


    const handleContrato = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage('');

        const formData = new FormData();
        formData.append('dni', dni);
        formData.append('codigo', verificationCode);

        try {
            const response = await fetch(`${sessi.ip}/api/codigo/contrato/`, {
                method: 'POST',
                body: formData
            });

            if (response.ok) {
                const data = await response.json();
                // Navega hacia /Contrato y pasa los datos como estado
                sessi.setVariable("codigoContrato", verificationCode);
                navigate('/Contrato', { state: { nombre: data.NombreCompleto, email: data.email, dni: data.dni, codigo: data.codigo } });
            } else {
                const errorData = await response.json();
                const errorMessage = errorData.error === "Código no encontrado."
                    ? "El código ingresado es incorrecto"
                    : errorData.error || 'Ocurrió un error inesperado.';

                setErrorMessage(errorMessage);
            }
        } catch (error) {
            //setErrorMessage('Ocurrió un error en la conexión con la API.');
            setErrorMessage('Error de conexión a internet.');
        } finally {
            setLoading(false);
        }
    };



    const [timeLeft, setTimeLeft] = useState(900); // 900 segundos = 15 minutos

    // Reiniciar el contador cuando el modal se abra
    useEffect(() => {
        if (showModalCodigo) {
            setTimeLeft(900); // Reinicia el contador a 15 minutos cuando se abre el modal
        }
    }, [showModalCodigo]);

    // Actualiza el contador cada segundo
    useEffect(() => {
        let timerId;
        if (timeLeft > 0 && showModalCodigo) {
            timerId = setInterval(() => {
                setTimeLeft((prevTimeLeft) => prevTimeLeft - 1);
            }, 1000);
        }

        return () => clearInterval(timerId); // Limpia el intervalo al cerrar el modal o cambiar el estado
    }, [timeLeft, showModalCodigo]);

    // Formato del tiempo en MM:SS
    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };


    return (
        <>
            <section id="inicio">
                {/* header section starts */}
                <header className="header_section" style={{ backgroundColor: '#72D2DA' }}>
                    <div className="container-fluid">
                        <nav className="navbar navbar-expand-lg custom_nav-container">
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Lottie loop animationData={mouseAnimation} play style={{ width: isMobile ? '30px' : '50px', height: 'auto' }} />
                                <a className="navbar-brand" href="#">
                                    <div className="brand_text">
                                        <img src={LogoDigital} alt="Logo Digital" style={{ width: isMobile ? '150px' : '250px', height: 'auto', marginLeft: 10 }} />
                                    </div>
                                </a>
                            </div>

                            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span className=""> </span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                <ul className="navbar-nav">
                                    <li className="nav-item">
                                        <Link to="/" className="nav-link"><b>Ir a Inicio</b></Link>
                                    </li>
                                    {isMobile2 && (
                                        <li className="nav-item">
                                            <Link to="/Login" className="nav-link"><b>Iniciar Sesión</b></Link>
                                        </li>
                                    )}
                                </ul>
                                <div className="quote_btn-container">
                                    <Link to="/Login" className="quote_btn">Iniciar Sesión</Link>
                                </div>
                            </div>
                        </nav>
                    </div>
                </header>
                {/* end header section */}


                {/* SERVICIOS DISPONIBLES */}
                <section id="servicios-disponibles">
                    <section className="service_section layout_padding">
                        <div className="container">
                            <div className="heading_container">
                                <h2>Servicios Disponibles</h2>
                                <p>Realiza tus trámites de forma 100% en línea desde cualquier lugar, ya sea tu hogar o lugar de trabajo, sin necesidad de trasladarte a nuestras oficinas:</p>
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-md-6 col-lg-3">
                                    <div className="box">
                                        <div className="img-box">
                                            <img src={prestamo} alt="" />
                                        </div>
                                        <div className="detail-box">
                                            <h5>Solicitud de Preanálisis de Préstamo</h5>
                                            <p>Descubre tu monto a otorgar solicitando tus preanálisis de préstamos personales e hipotecarios adjuntando la documentación requerida.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-3">
                                    <div className="box">
                                        <div className="img-box">
                                            <img src={documento} alt="" />
                                        </div>
                                        <div className="detail-box">
                                            <h5>Constancia de Pensionado</h5>
                                            <p>Descarga tu constancia de pensionado fácilmente, sin complicaciones, desde nuestro portal en tan solo un clic.</p>
                                            <br></br>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-3">
                                    <div className="box">
                                        <div className="img-box">
                                            <img src={ahorro} alt="" />
                                        </div>
                                        <div className="detail-box">
                                            <h5>Visualizar Saldo de Cotizaciones</h5>
                                            <p>Visualiza tu saldo cotizado, promedio de salarios cotizados, pensión aproximada y tus últimos salarios cotizados.</p>
                                            <br></br>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-3">
                                    <div className="box">
                                        <div className="img-box">
                                            <img src={hombre} alt="" />
                                        </div>
                                        <div className="detail-box">
                                            <h5>Envío de Quejas y Sugerencias</h5>
                                            <p>Ayúdanos a seguir mejorando al compartir tus quejas o sugerencias sobre los servicios del INJUPEMP.</p>
                                            <br></br>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="btn-box">
                                <Link to="/Login" className="quote_btn">¿Tiene ya acceso? Conéctese aquí</Link>
                            </div>
                        </div>
                    </section>
                </section>
                {/* Fin Servicios Disponibles */}
                <div className="footer_container">
                    <section className="info_section">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6 col-lg-3">
                                    <div className="info_detail">
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                            <h4 style={{ marginBottom: '10px' }}>INJUPEMP Conectados</h4>
                                            <Lottie loop animationData={mouseAnimation} play style={{ width: isMobile ? '30px' : '50px', height: 'auto' }} />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-lg-3 mb-0 ml-auto">
                                    <div className="info_contact">
                                        <h4>
                                            Contacto y Soporte
                                        </h4>
                                        <div className="contact_link_box">
                                            <a href="https://maps.app.goo.gl/pmvUaL48qTr24pPY6" target='_blank'>
                                                <i className="fa-solid fa-location-dot"></i>
                                                <span>
                                                    Loma Linda Norte, Ave La FAO, Tegucigalpa D.C.
                                                </span>
                                            </a>
                                            <a href="tel:+50422901900">
                                                <i className="fa fa-phone" aria-hidden="true"></i>
                                                <span>
                                                    +504 2290-1900 OPCIÓN #3
                                                </span>
                                            </a>
                                            <a href="mailto:info@injupemp.gob.hn">
                                                <i className="fa fa-envelope" aria-hidden="true"></i>
                                                <span>
                                                    info@injupemp.gob.hn
                                                </span>
                                            </a>

                                        </div>
                                    </div>
                                    <div className="info_social">
                                        <a href="https://www.facebook.com/injupemp/" target="_blank">
                                            <i className="fa-brands fa-facebook" aria-hidden="true"></i>
                                        </a>
                                        <a href="https://x.com/injupemp?lang=en" target="_blank">
                                            <i className="fa-brands fa-x-twitter" aria-hidden="true"></i>
                                        </a>
                                        <a href="https://www.youtube.com/@injupemphonduras1770" target="_blank">
                                            <i className="fa-brands fa-youtube" aria-hidden="true"></i>
                                        </a>
                                        <a href="https://www.instagram.com/injupempHn/?hl=en" target="_blank">
                                            <i className="fa-brands fa-instagram" aria-hidden="true"></i>
                                        </a>
                                        {<a href="https://wa.link/kbcxjr" target="_blank">
                                            <i className="fa-brands fa-whatsapp" aria-hidden="true"></i>
                                        </a>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {<Tooltip title="Ir al ChatBot INJUPEMP Virtual" placement='left' arrow>
                        <a
                            href="https://wa.link/kbcxjr"
                            className="btn-wsp"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaWhatsapp className="icono" />
                        </a>
                    </Tooltip>}

                    <footer className="footer_section">
                        <div className="container">
                            <p>
                                <a href="https://www.injupemp.gob.hn/">INJUPEMP</a>
                                &copy; <span id="displayYear"></span> Todos los derechos reservados
                            </p>
                        </div>
                    </footer>
                </div>

                <script src="js/jquery-3.4.1.min.js"></script>
                <script src="https://cdn.jsdelivr.net/npm/popper.js@1.16.0/dist/umd/popper.min.js"
                    integrity="sha384-Q6E9RHvbIyZFJoft+2mJbHaEWldlvI9IOYy5n3zV9zzTtmI3UksdQRVvoxMfooAo" crossOrigin="anonymous">
                </script>
                <script src="js/bootstrap.js"></script>
                <script src="js/custom.js"></script>
                <script
                    src={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""}`}
                    async
                ></script>
                <script src="js/scrolling-nav.js"></script>

                <Modal
                    show={showResultModal}
                    onHide={handleClose}
                    dialogClassName="custom-modal"
                >
                    <Modal.Header closeButton={false} className="d-flex justify-content-between align-items-center">
                        <Modal.Title>Resultado de la verificación</Modal.Title>
                        <Button
                            className="close"
                            onClick={handleClose}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                backgroundColor: 'transparent',
                                border: 'none'
                            }}
                        >
                            <i className="fas fa-times" aria-hidden="true"></i>
                        </Button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="d-flex align-items-center">
                            <i className={`fas ${resultType === 'error' ? 'fa-times-circle' : 'fa-check-circle'} fa-2x mr-2 ${resultType === 'error' ? 'text-danger' : 'text-success'}`}></i>
                            <p className="mb-0 text-dark">{resultMessage}</p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        {/* Condición para mostrar el nuevo botón */}
                        {showChangeEmailButton && (
                            <Button variant="primary" onClick={handleChangeEmailClick} style={{
                                backgroundColor: '#72D2DA',
                                borderColor: '#72D2DA',
                                color: '#fff',
                                marginRight: 10,
                                fontWeight: 'bold'
                            }}>
                                Solicitar Cambio De Correo
                            </Button>
                        )}
                        <Button variant="secondary" onClick={handleClose}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>


                {/* El modal para verificación de datos sigue igual */}
                <Modal
                    show={showModal}
                    onHide={handleClose}
                    dialogClassName="custom-modal"
                >
                    <Modal.Header closeButton={false} className="d-flex justify-content-between align-items-center">
                        <Modal.Title>Verificación de Datos</Modal.Title>
                        <Button
                            className="close"
                            onClick={handleClose}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                backgroundColor: 'transparent',
                                border: 'none'
                            }}>
                            <i className="fas fa-times" aria-hidden="true"></i>
                        </Button>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="formBasicPassword">
                                <Form.Label>Número de Identidad</Form.Label>
                                <Form.Control
                                    type="tel"
                                    inputMode="numeric"
                                    placeholder="Introduce tu número de identidad"
                                    value={dni}
                                    style={{ width: isMobile ? 280 : 400 }}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*$/.test(value)) {
                                            setDni(value);
                                        }
                                    }}
                                    required
                                />
                            </Form.Group>

                            <Form.Group controlId="formBasicEmail">
                                <Form.Label style={{ marginTop: 15 }}>Correo Electrónico</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Introduce tu correo electrónico"
                                    value={correo}
                                    style={{ width: isMobile ? 280 : 400 }}
                                    onChange={(e) => setCorreo(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            {/* Mostrar mensaje de error si existe */}
                            {errorMessage2 && (
                                <Alert severity="error" style={{ marginTop: '10px', width: isMobile ? 280 : 400, marginTop: 15 }}>
                                    {errorMessage2}
                                </Alert>
                            )}

                            <div className="d-flex justify-content-center" style={{ marginTop: 20 }}>
                                <Button
                                    variant="primary"
                                    type="submit"
                                    style={{
                                        backgroundColor: '#72D2DA',
                                        borderColor: '#72D2DA',
                                        color: '#fff',
                                        marginRight: 10,
                                        fontWeight: 'bold'
                                    }}
                                    disabled={loading}
                                    onClick={handleVerify}
                                >
                                    {loading ? (
                                        <>
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                style={{ color: '#fff' }}
                                            />
                                            &nbsp;Verificando...
                                        </>
                                    ) : (
                                        'Verificar'
                                    )}
                                </Button>
                                <Button
                                    variant="secondary"
                                    onClick={handleClose}
                                    style={{
                                        backgroundColor: '#6c757d',
                                        borderColor: '#6c757d',
                                        color: '#fff',
                                    }}
                                >
                                    Cerrar
                                </Button>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>

                {/* El modal para el código de 4 dígitos */}
                <Modal
                    show={showModalCodigo}
                    onHide={handleCloseCodigo}
                    dialogClassName="custom-modal"
                >
                    <Modal.Header closeButton={false} className="d-flex justify-content-between align-items-center">
                        <Modal.Title>Código de verificación</Modal.Title>
                        <Button
                            className="close"
                            onClick={handleCloseCodigo}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                backgroundColor: 'transparent',
                                border: 'none'
                            }}>
                            <i className="fas fa-times" aria-hidden="true"></i>
                        </Button>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Ingrese el código de 6 dígitos enviado al correo electrónico proporcionado.</p>
                        <p>
                            <b>Nota:</b> El código tiene una duración de 15 minutos. Si sales de esta ventana el código expirará.
                        </p>
                        <Form onSubmit={handleContrato}>
                            <Form.Group controlId="formVerificationCode">
                                <Form.Control
                                    type="text"
                                    inputMode="numeric"
                                    placeholder="Ingrese el código de 6 dígitos"
                                    value={verificationCode}
                                    style={{ width: isMobile ? 280 : 400 }}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // Permitir solo números y hasta 4 dígitos
                                        if (/^\d{0,6}$/.test(value)) {
                                            setVerificationCode(value);
                                        }
                                    }}
                                    required
                                />
                            </Form.Group>
                            <div style={{ textAlign: 'center', fontSize: '18px', fontWeight: 'bold', marginBottom: '20px', marginTop: 10 }}>
                                Tiempo restante: {formatTime(timeLeft)}
                            </div>

                            {/* Muestra el mensaje de error si existe */}
                            {errorMessage && (
                                <Alert severity='error' style={{ marginTop: '10px' }}>
                                    {errorMessage}
                                </Alert>
                            )}

                            <div className="d-flex justify-content-center" style={{ marginTop: 5 }}>
                                <Button
                                    variant="primary"
                                    type="submit"
                                    style={{
                                        backgroundColor: '#72D2DA',
                                        borderColor: '#72D2DA',
                                        color: '#fff',
                                        fontWeight: 'bold'
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                style={{ color: '#fff' }}
                                            />
                                            &nbsp;Enviando...
                                        </>
                                    ) : (
                                        'Validar Código'
                                    )}
                                </Button>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>

            </section>
        </>
    );
};

export default ServiciosPortal;

